import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
config({ licenseKey });

console.log('%c Keystone Portal ', 'background: #0066cc; color: white; font-weight: bold; padding: 4px 8px;');
console.log('Version:', environment.version);
console.log('Build:', environment.build);
console.log('Build Timestamp:', environment.buildTimestamp);
console.log('Environment:', environment.production ? 'Production' : 'Staging/Dev');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })], })
  .catch(err => console.error(err));
